import styled from 'styled-components'
import { colors } from 'client/styles'

export const CapacityBase = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.grey2};
  font-size: 14px;

  > p {
    margin-inline-end: 10px;

    &::after {
      content: ':';
    }
  }
`

export const Paxes = styled.div<{ showIcons: boolean; showTitle: boolean }>`
  display: flex;
  flex-wrap: wrap;

  margin-inline-start: ${props => (props.showIcons && props.showTitle ? '8px' : 0)};
  margin-inline-end: 4px;

  > svg {
    fill: ${colors.grey2};
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
  }
`

export const Adults = styled.div`
  display: flex;
  align-items: center;
  margin-inline: 2px;
  margin-block: 0;
`

export const Children = styled.div`
  display: flex;
  align-items: center;
`

export const IconWrapper = styled.div`
  margin-inline-end: 8px;

  > svg {
    fill: ${colors.grey2};
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
  }
`

export const Separator = styled.div`
  display: flex;
  align-items: center;
`
